import { FilterBase } from "../filterBase"
import { DATA_TYPES } from "../filterConstants"

export class NumberFilter extends FilterBase {
  constructor(filterName, filterType, dataScopes, information, visibility, restrictedToScope) {
    super(
      filterName,
      filterType,
      DATA_TYPES.NUMBER,
      dataScopes,
      information,
      visibility,
      restrictedToScope,
    )
  }

  isValueValid(value) {
    return !Number.isNaN(Number(value)) || value === "-"
  }

  formatCompareData(a, b) {
    return [a, b]
  }

  additionalFilters(data) {
    return data.filter((row) => {
      return (
        (row[this.filterType] || row[this.filterType] === 0) &&
        this.filterBasedOnOperator(row[this.filterType], Number(this.value))
      )
    })
  }

  filterBasedOnOperator(a, b) {
    switch (this.operator) {
      case ">=":
        return a >= b
      case "<=":
        return a <= b
      default:
        return a === b
    }
  }
}
